// Phone popup (header "call" link -> #phone-call-box). Plain JS, no jQuery required.
document.addEventListener('DOMContentLoaded', function () {
  var link = document.getElementById('top-phone-link');
  var box = document.getElementById('phone-call-box');
  if (!link || !box) return;

  link.addEventListener('click', function (e) {
    e.preventDefault();
    box.classList.add('active');
  });

  var close = box.querySelector('.close');
  if (close) {
    var hide = function () { box.classList.remove('active'); };
    close.addEventListener('click', hide);
    close.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); hide(); }
    });
  }
});
